import {
  ADMIN,
  CURATOR,
  CUSTOMER,
  DEVELOPER,
  QUALITY_ASSURANCE,
} from "entities/user/role";
import useRole from "hooks/useRole";
import { DefaultPermission } from "utils/permission";

export default function useSurveysPermissions(): DefaultPermission {
  const { hasRole, hasNotRole } = useRole();

  return {
    canCreate: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CURATOR),
    canEdit: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CURATOR),
    canDelete: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CURATOR),
    canList: hasNotRole(CUSTOMER),
    canShow: hasNotRole(CUSTOMER),
  };
}
